import React, { Component } from 'react';
import { connect } from 'react-redux'
import * as act from '../../actions';
import { REACT_APP_URL } from '../../services/api-config';
import ItemDetail from './ItemDetail';
import { Link } from 'react-router-dom'
import WordSearchForm from '../wordsearchscreens/WordSearchForm'
import ReactGA from 'react-ga';
ReactGA.initialize('UA-86407471-10');

/*
import ItemDetail from './ItemDetail.jsx';
import NotesView from './NotesView.jsx';
import BibliographyView from './BibliographyView.jsx';
import MetadataView from './MetadataView.jsx';
import WordSearchForm from './WordSearchForm.jsx';
import { browserHistory, Router, Route, Link, Redirect, hashHistory } from 'react-router';
import update from 'react-addons-update'; // ES6
import 'whatwg-fetch';
import * as FontAwesome from 'react-icons/lib/fa'
*/

let uniqueTables = []
class ItemView extends Component {
  constructor(props) {
     super(props);
     this.state = {
       key: 1
     }
     this.handleSelect = this.handleSelect.bind(this)
     this.props.history.listen((location, action) => {
      // console.log(location)
       this.props.getTable(location.pathname.match(/\d+$/))

      //  console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`)
      //  console.log(`The last navigation action was ${action}`)
    })

   }


componentDidMount(){

  if (this.props.data ) {
    uniqueTables = this.props.data.reduce(function (acc, curr) {
     let isIndex = acc.some(function(x) { return x.id === curr.id });
       //  let isIndex = acc.findIndex(x => x.id === curr.id)
     if (curr.active === true && !isIndex) {
     acc = [...acc,curr]
   }
 return acc;
}, []);
    if (this.props.history.location.pathname !== REACT_APP_URL){
    this.props.history.push(this.props.history.location.pathname)
  } else this.props.history.push(REACT_APP_URL+this.props.data[0].id)
} else this.props.history.replace(this.props.history.location.pathname);
}

componentDidUpdate(nextProps) { // or componentDidUpdate

  if (nextProps.data !== this.props.data) {
     uniqueTables = this.props.data.reduce(function (acc, curr) {
      let isIndex = acc.some(function(x) { return x.id === curr.id });
        //  let isIndex = acc.findIndex(x => x.id === curr.id)

      if (curr.active === true && !isIndex) {
      acc = [...acc,curr]
    }
  return acc;
}, []);

    if (this.props.history.location.pathname !== REACT_APP_URL+uniqueTables[0].id){
    this.props.history.push(REACT_APP_URL+uniqueTables[0].id)
  } else this.props.history.replace(REACT_APP_URL+uniqueTables[0].id)

  }
  ReactGA.pageview(this.props.history.location.pathname);
}



handleSelect(key, e) {
  e.preventDefault();
   this.setState({key: key});
   return false;
 }




  render() {
    const {
      tables,
      wsReset
    } = this.props;
    let index;

    if (uniqueTables.length>0) {
      //før brukte vi findIndex men den er ikke støttet by IE
        //  index = uniqueTables.findIndex(x => x.id === parseInt(tables.item.id, 10)); //finner index i uniqueTables av denne tavlen
        uniqueTables.some(function(x, i) {
          return (x.id === parseInt(tables.item.id, 10)?index=i: null)

        });

        if (uniqueTables[index-1] !== undefined)
          var prev = <Link className="pull-left" to={{pathname: REACT_APP_URL+uniqueTables[index-1].id}}>Prev</Link>
        if (uniqueTables[index+1] !== undefined)
          var next = <Link className="pull-right" to={{pathname: REACT_APP_URL+uniqueTables[index+1].id}}>Next</Link>
    }


    return (
          <div className="row itemview">
             {this.props.data ?
            <ul className="nav nav-tabs" role="tablist">
                <li onClick={this.handleSelect.bind(this, 1)} role="presentation" className={this.state.key ===1 ? "active": ""}><a href="#table" aria-controls="profile" role="tab" data-toggle="tab">Document</a></li>
                <li onClick={this.handleSelect.bind(this, 2)} role="presentation" className={this.state.key ===2 ? "active": ""}><a href="#wordsearch" aria-controls="wordsearch" role="tab" data-toggle="tab">Word search</a></li>
                <li onClick={this.handleSelect.bind(this, 3)} role="presentation" className={this.state.key ===3 ? "active": ""}><a href="#multiplewordsearch" aria-controls="wordsearch" role="tab" data-toggle="tab">Multiple Word search</a></li>
               
            </ul>
 : null }
            <div className="tab-content">
                {Object.keys(tables).length !== 0?<div role="tabpanel" className={this.state.key !==1 ? "hide": "tab-pane active show"}><ItemDetail newwindow={this.props.newwindow?true:false} item={tables} count={uniqueTables.length} index={index !== undefined?index+1:null} prev={prev} next={next}/></div>:null}

                <div role="tabpanel" className={this.state.key !==2 ? "hide": " tab-pane active show"}><WordSearchForm mode="single" maxRepeat={1}  minRepeat={1} key={wsReset}/></div>
                <div role="tabpanel" className={this.state.key !==3 ? "hide": " tab-pane active show"}><WordSearchForm mode="multiple" maxRepeat={5} minRepeat={1}  key={wsReset}/></div>
              </div>
        </div>
    );

  }
}

function mapStateToProps(state) {
  return {
    tables: state.tables,
    wsReset: state.wsReset
  };
}
 export default connect(mapStateToProps, act)(ItemView);



// WEBPACK FOOTER //
// ./src/components/itemscreens/ItemView.js